import React from 'react';
import { CaretLeftIcon, CaretRightIcon } from '../../../../icon';
import { IconButton } from '../../../icon-button';
import {
  CalendarContainer,
  CalendarMonth,
  CalendarControl,
  CalendarWeekHeader,
  CalendarTitle,
  CalendarMonths,
  CalendarYears,
} from '../../atoms';
import { SELECT_BY_MAP, useCalendarState } from '../../provider';
import { CalendarCommonStyles } from '../common-styles';
import { CalendarControlsStyles } from './styles';

export const DialogCalendarDisplay = () => {
  const { months, selectBy } = useCalendarState();
  const { month, year, weeks } = months[0]!;
  const calWeekHeaderStyle = CalendarCommonStyles.calWeekHeaderStyles({
    fontWeight: 'bold',
  });
  const calContainerStyle = CalendarCommonStyles.calContainerStyles();
  const calContainerVars = CalendarCommonStyles.calContainerVars();
  const controlsHeader = CalendarControlsStyles.controlsHeader;
  const monthName = CalendarControlsStyles.monthName;
  const calendarControls = CalendarControlsStyles.calendarControls;

  return (
    <CalendarContainer className={calContainerStyle} style={calContainerVars}>
      <header className={controlsHeader}>
        <CalendarControl
          renderPrevButton={(props) => (
            <IconButton label={`Previous ${SELECT_BY_MAP[selectBy]}`} showLabelOnHover type='button' {...props}>
              <CaretLeftIcon color='light' />
            </IconButton>
          )}
          renderNextButton={(props) => (
            <IconButton label={`Next ${SELECT_BY_MAP[selectBy]}`} showLabelOnHover type='button' {...props}>
              <CaretRightIcon color='light' />
            </IconButton>
          )}
          className={calendarControls}
        >
          <CalendarTitle month={month} year={year} className={monthName} />
        </CalendarControl>
      </header>
      {selectBy === 'day' && (
        <React.Fragment>
          <CalendarWeekHeader className={calWeekHeaderStyle} />
          <CalendarMonth weeks={weeks} />
        </React.Fragment>
      )}
      {selectBy === 'month' && <CalendarMonths month={month} year={year} />}
      {selectBy === 'year' && <CalendarYears year={year} />}
    </CalendarContainer>
  );
};
